import React from "react";
import PropTypes from "prop-types";
import "../css/metrics.css";

const QualityMetrics = ({ data }) => (
  <div className="chart-card">
    <h3 className="chart-title">AI Response Quality</h3>
    <div className="quality-metrics">
      <div className="quality-metric">
        <div className="metric-header">
          <span className="metric-label">Response Accuracy</span>
          <span className="metric-value">{data.responseAccuracy}%</span>
        </div>
        <div className="metric-bar">
          <div
            className="metric-fill"
            style={{
              width: `${data.responseAccuracy}%`,
              backgroundColor: "#10B981",
            }}
          />
        </div>
      </div>
      <div className="quality-metric">
        <div className="metric-header">
          <span className="metric-label">Student Satisfaction</span>
          <span className="metric-value">{data.studentSatisfaction}%</span>
        </div>
        <div className="metric-bar">
          <div
            className="metric-fill"
            style={{
              width: `${data.studentSatisfaction}%`,
              backgroundColor: "#6366F1",
            }}
          />
        </div>
      </div>
      <div className="quality-metric">
        <div className="metric-header">
          <span className="metric-label">Citation Usage</span>
          <span className="metric-value">{data.citationUsage}%</span>
        </div>
        <div className="metric-bar">
          <div
            className="metric-fill"
            style={{
              width: `${data.citationUsage}%`,
              backgroundColor: "#F59E0B",
            }}
          />
        </div>
      </div>
      <div className="helpful-responses">
        <span className="helpful-label">Helpful Responses</span>
        <span className="helpful-value">
          {data.helpfulResponses} / {data.totalResponses}
        </span>
      </div>
    </div>
  </div>
);

QualityMetrics.propTypes = {
  data: PropTypes.shape({
    responseAccuracy: PropTypes.number.isRequired,
    studentSatisfaction: PropTypes.number.isRequired,
    citationUsage: PropTypes.number.isRequired,
    helpfulResponses: PropTypes.number.isRequired,
    totalResponses: PropTypes.number.isRequired,
  }).isRequired,
};

export default QualityMetrics;
